import React from "react";
import { PlusIcon } from "../../../../../../components/FileRepo/Icons.jsx";

/**
 * Presentational subject picker: chips, manual input and suggestions.
 * Holds no state and makes no API calls — the caller owns both, so the same
 * markup can back the onboarding wizard step and the standalone popup.
 */
const SubjectSelector = ({
  subjects = [],
  onAdd,
  onRemove,
  suggestions = [],
  inputValue = "",
  onInputChange,
  error,
  label = "Enter your subjects",
}) => {
  const isAddDisabled = (inputValue ?? "").trim() === "";

  const handleKeyUp = (event) => {
    if (event.key === "Enter" && event.target.value.trim() !== "") {
      event.preventDefault();
      onAdd(event.target.value);
      onInputChange("");
    }
  };

  const handleAddClick = (event) => {
    event.preventDefault();
    onAdd(inputValue);
    onInputChange("");
  };

  return (
    <>
      <p className="subjects-title">{label}</p>
      {subjects.length > 0 && (
        <div className="Subjects-you-teach-feilds-folder">
          {subjects.map((subject, index) => (
            <div key={index} className="Subjects-you-teach-feilds">
              <p>{subject}</p>
              <a
                className="subject-delete-btn"
                onClick={() => onRemove(subject)}
              >
                <i className="fa-solid fa-xmark"></i>
              </a>
            </div>
          ))}
        </div>
      )}
      <div className="add_feild-btn">
        <div className="Subjects-you-teach">
          <input
            value={inputValue}
            name="subject"
            spellCheck
            type="text"
            placeholder="Add custom subject"
            onKeyUp={handleKeyUp}
            onChange={(e) => {
              e.preventDefault();
              onInputChange(e.target.value);
            }}
          />
        </div>
        <button
          type="button"
          className="add_subject_feild_btn flex items-center justify-center gap-1"
          onClick={handleAddClick}
          disabled={isAddDisabled}
          style={{ backgroundColor: isAddDisabled && "#CCCCCC" }}
        >
          Add <PlusIcon w={12} h={12} />
        </button>
      </div>

      <div className="Subjects-you-teach-suggestions-container">
        <p className="Subjects-you-teach-suggestions-title"></p>
        <div className="Subjects-you-teach-suggestions-folder">
          {suggestions
            ?.filter((obj) => obj?.name !== "" && !subjects.includes(obj?.name))
            .map((obj, index) => (
              <a key={index} onClick={() => onAdd(obj.name)}>
                {obj.name}
              </a>
            ))}
        </div>
      </div>
      <p className="errorState">{error}</p>
    </>
  );
};

export default SubjectSelector;
